import { useEffect, useId, useState, type ReactElement } from 'react';

import { Modal } from '@/components/admin/Modal';

/**
 * 破壊的操作の確認モーダル（指示書 §7-3）。
 * 監査対象の操作は理由入力を必須にする（§8: CSV確定などは理由必須）。
 * モーダルの土台（オーバーレイ・Escape・背景クリック）は Modal と共通（D-094）。
 */
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = '実行する',
  requireReason = false,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  title: string;
  message?: string;
  confirmLabel?: string;
  requireReason?: boolean;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}): ReactElement | null {
  const [reason, setReason] = useState('');
  const reasonId = useId();

  useEffect(() => {
    if (!open) setReason('');
  }, [open]);

  const canConfirm = !requireReason || reason.trim().length > 0;

  return (
    <Modal
      open={open}
      title={title}
      onClose={onCancel}
      footer={
        <>
          <button
            type="button"
            onClick={onCancel}
            className="btn-secondary"
          >
            キャンセル
          </button>
          <button
            type="button"
            disabled={!canConfirm}
            onClick={() => onConfirm(reason)}
            className="rounded-sm border border-transparent bg-wpnotice-error px-3.5 py-2 text-white hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-40"
          >
            {confirmLabel}
          </button>
        </>
      }
    >
      {message && <p className="mb-3 text-wptext">{message}</p>}
      {requireReason && (
        <div>
          <label htmlFor={reasonId} className="mb-1.5 block text-wptext-muted">
            理由（監査ログに記録されます）
          </label>
          <textarea
            id={reasonId}
            required
            rows={3}
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            className="w-full rounded-sm border border-wpborder px-3 py-2"
          />
        </div>
      )}
    </Modal>
  );
}
